<template>
    <div id="m-inbox" style="height: 100%">
        <v-overlay v-if="loading">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>
        <v-alert type="error" width="20%" v-else-if="message" style="margin-top: 50px;margin-left: 50%;left: -10%;">
            {{ message }}
        </v-alert>
        <v-card v-else elevation="0">
            <v-card-actions v-if="usersCountPerPackage.length != 0" class="ma-0 pa-0 mx-2 my-2">
                <v-card outlined width="100%" class="ma-0 pa-0">
                    <v-card-actions class="ma-0 pa-0">
                        <v-data-table
                                style="width: 100%;"
                                fixed-header
                                :headers="header"
                                :items="usersCountPerPackage"
                                hide-default-footer
                                disable-pagination>
                        </v-data-table>
                    </v-card-actions>
                </v-card>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import {InfoStoreUtils} from "@/modules/minfo/database/InfoStoreUtils";

export default {
    name: "i-users-by-package-id",
    components: {},
    data: () => ({
        header: [
            {text: 'Package Id', sortable: true, value: 'packageId', class: "white blue--text", color: "red"},
            {text: 'Users', sortable: true, value: 'count', class: "white blue--text", color: "red"},
        ],
        loading: false,
        message: "",
    }),
    created() {
        this.getUsersByPackageId()
    },
    computed:{
        usersCountPerPackage(){
             return InfoStoreUtils.getUsersCountPerPackage()
         }
    },
    methods: {
        reloadData(){
            this.getUsersByPackageId()
        },
        //getMyUserUid(){
            //return PermissionsStoreUtils.getMyUserUid();
        //},
        //ifCanDeleteInfo(){
            //return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.INFO_TAB.subpermissions.INFO_TAB_DELETE.id)
        //},
        getUsersByPackageId(){
            InfoStoreUtils.fethUsersCountPerPackage()
            .then(() => {
                this.$notify({title: 'Succes!', text: "", type: "succes"});
            })
            .catch((error) => {
                this.$notify({title: 'Fail!', text: error, type: "error"});
            })
        },
    },
}
</script>

<style scoped>
</style>